import { initializeApp } from 'firebase/app';
// firebase/auth/cordova avoids the browser-only gapi/iframe popup-redirect
// machinery, which throws (gapi.iframes.getContext undefined) and hangs auth
// init forever inside Capacitor's capacitor://localhost WKWebView on iOS.
// But that build doesn't support signInWithPopup, which the website's
// non-native login fallback needs — so only use it when actually running
// inside the native Capacitor app, not on the website sharing this bundle.
import { getAuth as getAuthWeb } from 'firebase/auth';
import { getAuth as getAuthCordova } from 'firebase/auth/cordova';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

const isNative = typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.();

export const app = initializeApp(firebaseConfig);
export const auth = isNative ? getAuthCordova(app) : getAuthWeb(app);
